import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllDashboards: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.footer.view-all-dashboards',
		defaultMessage: 'View all dashboards',
		description: 'Message for the view all dashboards menu item in the dashboards submenu',
	},
});
